import { useMemo } from 'react';

interface Props {
  value?: string | null;
  diameter?: number;
}
/**
 * Hex String
 */
export function HexString({ value, diameter }: Props) {
  const regexp = useMemo(() => {
    const numElements = diameter != null ? Math.round(diameter / 2) : 0xff;
    return new RegExp(`^(\\w{${numElements}}).*(\\w{${numElements}})$`);
  }, [diameter]);
  return <>{value?.replace(regexp, '$1...$2')}</>;
}
